import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import CommuteIcon from '@mui/icons-material/Commute'
import { useLang } from '~/hooks/useLang'

export default function ListVehiclesButton({ hasHistory, historyUrl }) {
  const { translate } = useLang()
  const ClickOpen = () => {
    window.open(
      historyUrl,
      'list-vehicles, width=auto, height=600, status = no'
    )
  }

  return (
    <Grid item>
      <Tooltip
        title={translate('See List Devices')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!hasHistory} onClick={ClickOpen}>
            <CommuteIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
